import type { IconData } from '@stacksjs/iconify-core'

export const screwdriverFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M42.337 1.809a1.5 1.5 0 0 0-1.75-.271l-5.906 3.06a2.5 2.5 0 0 0-1.35 2.158l-.091 3.76l-11.269 11.27a3 3 0 0 0 4.243 4.242L37.482 14.76l3.76-.092a2.5 2.5 0 0 0 2.16-1.35l3.06-5.906a1.5 1.5 0 0 0-.272-1.75z\"/><path fill=\"#2859c5\" d=\"M24.863 23.134a81 81 0 0 0-3.697-3.501c-1.718-1.511-4.165-1.555-5.954-.178c-1.602 1.233-3.994 3.228-6.866 6.1s-4.867 5.264-6.1 6.866c-1.377 1.789-1.333 4.236.178 5.954a81 81 0 0 0 3.5 3.697a81 81 0 0 0 3.698 3.502c1.718 1.51 4.165 1.555 5.954.178c1.602-1.234 3.994-3.23 6.866-6.1c2.872-2.873 4.867-5.264 6.1-6.867c1.378-1.789 1.334-4.236-.178-5.954a81 81 0 0 0-3.5-3.697Z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default screwdriverFlat
